import { render, staticRenderFns } from "./TrailerModal.vue?vue&type=template&id=fed3dfdc&scoped=true"
import script from "./TrailerModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrailerModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TrailerModal.vue?vue&type=style&index=0&id=fed3dfdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed3dfdc",
  null
  
)

export default component.exports